import { render, staticRenderFns } from "./ProjectOneThemeCustomerView.vue?vue&type=template&id=2c18a043&scoped=true&"
import script from "./ProjectOneThemeCustomerView.vue?vue&type=script&lang=js&"
export * from "./ProjectOneThemeCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOneThemeCustomerView.vue?vue&type=style&index=0&id=2c18a043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18a043",
  null
  
)

export default component.exports